export default {
  'APP_UPDT_FULFILLMENT_FACILITY': 'STOREFULFILLMENT_ADMIN',
  'APP_UPDT_PICKER_CONFG': 'STOREFULFILLMENT_ADMIN',
  'APP_USER_CREATE': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_UPDT_BLOCK_LOGIN': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_UPDT_PASSWORD': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_UPDT_PRODUCT_STORE_CONFG': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_SECURITY_GROUP_CREATE': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_PERMISSION_CREATE': 'SECURITY_CREATE OR SECURITY_ADMIN',
  'APP_PERMISSION_UPDATE': 'SECURITY_UPDATE OR SECURITY_ADMIN',
  'APP_PERMISSION_VIEW': 'SECURITY_VIEW OR SECURITY_ADMIN',
  'APP_SUPER_USER': 'WEBTOOLS_VIEW',
  'USERS_APP_VIEW': 'USERS_APP_VIEW',
  'APP_COMMERCE_VIEW': 'COMMERCEUSER_VIEW'
} as any